// extracted by mini-css-extract-plugin
export var row = "portfolioCompanies-module--row--hILUH";
export var arrow = "portfolioCompanies-module--arrow--2DpA1";
export var founder = "portfolioCompanies-module--founder--dNuSo";
export var openedFounder = "portfolioCompanies-module--openedFounder--1_eb8";